<template>
  <div class="wrap" v-if="InnerWidth">
    <div class="bgimg" v-if="ifLogin">
      <img
        src="https://partnersocialtest.intel.cn/files/test/upload_image/ce1627_1588143795335_1.png"
      />
      <div class="msg">
        <p class="tit">英特尔员工</p>
        <!-- <a
          class="btn"
          href="https://signin.intel.com/Login/AutoSignIn?flag=false&TARGET=https://sfederation.intel.com/federation2/sp/IntelPartnerProgrammanagementtool/aHR0cHM6Ly9wYXJ0bmVyc29jaWFsLmludGVsLmNu"
          >立即登录</a
        > -->
        <a
          class="btn"
          href="https://consumer.intel.com/intelcorpb2c.onmicrosoft.com/B2C_1A_UNIFIEDLOGIN_SISU_STD_SAML/generic/login?entityId=https://partnersocial.intel.cn/report/v2"
          >立即登录</a
        >
        <p style="width:600px;">
          新用户请到<a
            href="https://ags.intel.com/identityiq/home.jsf"
            target="blank"
          >
            AGS </a
          >申请以下权限，权限批准后，可立即登录。<br />Intel Partner
          Wechat_Reporting_Prod_View_IntelPMs
        </p>

        <p class="tit" style="padding-top:20px;">英特尔供应商</p>
        <a
          class="btn"
          href="https://consumer.intel.com/intelcorpb2c.onmicrosoft.com/B2C_1A_UNIFIEDLOGIN_SISU_STD_SAML/generic/login?entityId=https://partnersocial.intel.cn/report/v2"
          >立即登录</a
        >
        <p>
          新用户请<a
            href="https://www.intel.com/content/www/us/en/secure/forms/wechat-report-requests/enrollment.html"
            >点此注册</a
          >申请报告平台的登录权限，权限批准后，可立即登录。
        </p>
        <!-- <a
          class="btn"
          href="https://sfederation.intel.com/federation2/sp/IntelPartnerProgrammanagementtool/aHR0cHM6Ly9wYXJ0bmVyc29jaWFsLmludGVsLmNu"
          >立即登录</a
        >
        <p>
          新用户请<a
            href="https://www.intel.cn/content/www/cn/zh/forms/wechat-report-registration.html"
            >点此注册</a
          >申请报告平台的登录权限，权限批准后，可立即登录。
        </p> -->
        <br />
      </div>
    </div>
    <div class="card-wrap" v-if="false">
      <el-card class="box-card">
        <el-form :model="form">
          <el-form-item label class="info">
            <span>手机号</span>
            <el-input
              v-model="form.phone"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label class="info">
            <span>公司</span>
            <el-input
              v-model="form.verification"
              placeholder="请输入验证码"
              type
            ></el-input>
            <div class="verification">发送验证码</div>
          </el-form-item>
          <el-form-item label class="wx" style="margin-bottom: 10px">
            <img src="../assets/u31.png" alt="" />
            <span>微信登录</span>
          </el-form-item>
          <el-form-item label class="info">
            <router-link class="info-registered" to="/registered"
              >注册</router-link
            >
            <el-button type="primary" class="login">登录</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <div class="footer" v-if="ifLogin">
      <div class="navbar-collapse">
        <ul class="nav navbar-nav">
          <li>
            <img
              style="height:42px;padding: 0 20px;"
              src="https://partnersocialtest.intel.cn/files/test/upload_image/ce1627_1577331710418_intel-logo-highres.png"
            />
          </li>
          <li>|<a class="navbar-footer-brand" href="#">©英特尔公司</a></li>
          <li>| <a>沪 ICP 备 18006294 号-1</a></li>
          <li>
            |
            <a
              href="http://www.intel.cn/content/www/cn/zh/legal/terms-of-use.html?iid=ftr%20terms"
              target="loginTerms"
              >使用条款</a
            >
          </li>
          <li>
            |
            <a
              href="http://www.intel.cn/content/www/cn/zh/legal/trademarks.html"
              target="loginTrademarks"
              >*商标</a
            >
          </li>
          <li>
            |
            <a
              href="http://www.intel.cn/content/www/cn/zh/privacy/intel-online-privacy-notice-summary.html"
              target="loginPrivacy"
              >隐私条款</a
            >
          </li>
          <li>
            |
            <a
              href="http://www.intel.cn/content/www/cr/zh/privacy/intel-cookie-notice.html"
              target="loginCookies"
              >Cookie</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { login } from "../../api/";
import { getsubscribeStatus } from "../util/index";
import axios from "axios";
export default {
  name: "login",
  data() {
    return {
      form: {},
      InnerWidth: true,
      ifLogin: false,
      sid: ""
    };
  },
  created() {
    if (innerWidth <= 750) {
      this.InnerWidth = false;
      this.$message({
        message: "请在电脑端查看",
        type: "warning"
      });
      return;
    }
  },
  mounted() {
    this.$goLogin();
    if (
      window.localStorage.getItem("openid") &&
      window.localStorage.getItem("email") &&
      window.localStorage.getItem("memberOf")
    ) {
      this.ifLogin = false; //不显示登录注册
      if (
        window.localStorage.getItem("memberOf") &&
        window.localStorage.getItem("memberOf") != "null"
      ) {
        this.login();
      } else if (
        !window.localStorage.getItem("memberOf") ||
        window.localStorage.getItem("memberOf") == "null"
      ) {
        // 没有权限，跳转到权限审核页面
        this.$router.push("/noaccess");
      }
    } else {
      this.ifLogin = true;
    }
  },
  methods: {
    login() {
      localStorage.removeItem("token");
      localStorage.removeItem("Houtoken");
      axios
        .post(`${this.$store.state.HouUrl}/manager/login.do`, {
          username: "zhanghailing",
          password: 111111
        })
        .then(res => {
          window.localStorage.setItem("Houtoken", res.headers.authorization);
          login({ code: "opPcI1JQXgjSGkNbLsTo8SofvC-s" }).then(response => {
            let that = this;
            const authorization = response.headers.authorization;
            window.localStorage.setItem("token", authorization);
            setTimeout(function() {
              that.$router.push("/admin");
            }, 1000);
          });
        });
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html {
  background: white;
}
.wrap {
  box-sizing: border-box;
  background: white !important;
}
.box-card {
  width: 400px;
  margin: 0 auto;
}
.info .el-form-item__content {
  display: flex !important;
}
.info .el-form-item__content span {
  flex: 1;
}
.info .el-form-item__content .el-input {
  flex: 4;
}
.verification {
  position: absolute;
  right: 15px;
  color: #0066cc;
}
.login {
  position: absolute;
  right: 0;
  width: 50%;
}
.info-registered {
  color: #0066cc;
}
.wx {
  text-align: right;
}
.wx img {
  position: absolute;
  top: 7px;
  right: 70px;
}
.qrcode {
  width: 200px;
  height: 200px;
  margin: auto auto;
  padding-top: 150px;
}

.bgimg {
  width: 100%;
  height: auto;
  position: relative;
}
.bgimg img {
  width: 100%;
  height: auto;
}
.msg {
  position: absolute;
  top: 14.8%;
  left: 10%;
  padding: 20px 34px 0 34px;
  background: rgba(0, 0, 0, 0.3);
  line-height: 1.8;
  /* height: 55.68%; */
  width: 536px;
  color: #fff;
}
.msg .tit {
  font-size: 21px;
  color: #fff;
  font-weight: bold;
}
.msg a,
.msg p {
  color: #fff;
  font-size: 13px;
  display: block;
}
.msg a {
  color: #00aeef;
  display: inline;
  text-decoration: underline;
  font-size: 13px;
}
.msg .btn {
  font-size: 16px;
  color: #fff;
  padding: 4px 14px;
  background: #00aeef;
  display: inline-block;
  margin: 10px 0 18px 0px;
  text-decoration: none;
  font-weight: 400;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue